import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

export default function AddToFavPharmIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.03544 0.927068C7.33479 0.00575739 8.6382 0.00575525 8.93755 0.927066L10.1194 4.56435C10.2533 4.97638 10.6372 5.25534 11.0704 5.25534H14.8949C15.8636 5.25534 16.2664 6.49495 15.4827 7.06435L12.3886 9.31232C12.0381 9.56697 11.8915 10.0183 12.0254 10.4304L13.2072 14.0676C13.5065 14.989 12.4521 15.7551 11.6683 15.1857L8.57428 12.9377C8.2238 12.6831 7.7492 12.6831 7.39871 12.9377L4.30465 15.1857C3.52094 15.7551 2.46646 14.989 2.76581 14.0676L3.94764 10.4304C4.08151 10.0183 3.93485 9.56697 3.58436 9.31232L0.490304 7.06436C-0.29341 6.49495 0.109365 5.25534 1.07809 5.25534H4.90256C5.33578 5.25534 5.71974 4.97638 5.85361 4.56435L7.03544 0.927068Z"
          fill="#36607C"
        />
        <path
          d="M16.4863 10.5C16.4863 12.433 14.9193 14 12.9863 14C11.0533 14 9.48633 12.433 9.48633 10.5C9.48633 8.567 11.0533 7 12.9863 7C14.9193 7 16.4863 8.567 16.4863 10.5Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.9863 13.5C14.6432 13.5 15.9863 12.1569 15.9863 10.5C15.9863 8.84315 14.6432 7.5 12.9863 7.5C11.3295 7.5 9.98633 8.84315 9.98633 10.5C9.98633 12.1569 11.3295 13.5 12.9863 13.5ZM12.9863 14C14.9193 14 16.4863 12.433 16.4863 10.5C16.4863 8.567 14.9193 7 12.9863 7C11.0533 7 9.48633 8.567 9.48633 10.5C9.48633 12.433 11.0533 14 12.9863 14Z"
          fill="#36607C"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.0342 8.16675C13.3011 8.16675 13.5175 8.38314 13.5175 8.65007V12.5167C13.5175 12.7836 13.3011 13 13.0342 13C12.7672 13 12.5508 12.7836 12.5508 12.5167V8.65007C12.5508 8.38314 12.7672 8.16675 13.0342 8.16675Z"
          fill="#36607C"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.451 10.5834C15.4511 10.8503 15.2347 11.0668 14.9678 11.0669L10.964 11.0682C10.697 11.0683 10.4806 10.852 10.4805 10.5851C10.4804 10.3182 10.6967 10.1017 10.9636 10.1016L14.9675 10.1002C15.2344 10.1001 15.4509 10.3164 15.451 10.5834Z"
          fill="#36607C"
        />
      </svg>
    </SvgIcon>
  );
}
